module.exports = __webpack_public_path__ + "img/facebook.6784c0e7.svg";